console.log("fixed-travel-modal");

document.addEventListener('DOMContentLoaded', function() {
  const heroSection = document.querySelector('#hero-travel.hero_travel');
  const fixedModal = document.querySelector('.fixed-travel-modal');
  const footer = document.querySelector('.footer');

  if (!heroSection || !fixedModal) {
    return;
  }

  let heroVisible = true;
  let footerVisible = false;

  function updateModalVisibility() {
    if (heroVisible || footerVisible) {
      fixedModal.classList.remove('is-visible');
      fixedModal.classList.add('is-hidden');
    } else {
      fixedModal.classList.remove('is-hidden');
      fixedModal.classList.add('is-visible');
    }
  }

  // Options pour l'Intersection Observer
  const observerOptions = {
    root: null, // viewport
    rootMargin: '0px',
    threshold: 0 // Déclenche dès qu'un pixel sort/entre du viewport
  };

  // Observer le hero section
  const heroObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      heroVisible = entry.isIntersecting;
      updateModalVisibility();
    });
  }, observerOptions);
  heroObserver.observe(heroSection);

  // Observer le footer
  if (footer) {
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        footerVisible = entry.isIntersecting;
        updateModalVisibility();
      });
    }, observerOptions);
    footerObserver.observe(footer);
  }
});
